// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"430":"14494dd3","453":"389ad393"}[chunkId] + ".chunk.js";
};